var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Closures"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.FabricReport.DEFECTIVES_LIST'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.DEFECTIVES_LIST')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.fmediaFourpointsystem,"otherData":{
          mediaName: '四分制表格',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaFourpointsystem',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }